<template>
<span>
<img
  :width="size"
  :height="size"
  src="../../assets/img/viber.svg" alt="">
</span>
</template>

<script>
export default {
  name: 'viber',
  props: {
    size: {
      type: Number,
      default: 512,
    },
  },
};
</script>

<style scoped>

</style>
